import React from "react"
import { Link } from "gatsby"
import styled from "styled-components"

const HeaderStyled = styled.div`
  background-color: #77ADCF;
  text-align: center;
  border-bottom: 1.5px solid #1E1E1E;
`

const Title = styled.div`
  font-size: 36px;
  padding-top: 44px;
`

const NavLinks = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;
`

const NavLink = styled.li`
  font-size: 20px;
  display: inline;
  margin: 0 10px;
`

const LinkStyled = styled(Link)`
  text-decoration: none;
`

export default function Header({ activeLinkIdx }) {
  return (
    <HeaderStyled>
      <Title>Nicholas Ulricksen</Title>
      <NavLinks>
        <NavLink><LinkStyled to="/about/">About</LinkStyled ></NavLink>
        <NavLink><LinkStyled to="/projects/">Projects</LinkStyled></NavLink>
        <NavLink><LinkStyled to="/contact/">Contact</LinkStyled></NavLink>
      </NavLinks>
    </HeaderStyled>
  )
}
